import { Switch, ToastMessage } from '@cokitchen/cokitchen-components';
import { CalendarAltIcon } from 'cokitchen-icons';
import React, { Fragment, useState } from 'react';
import './styles.scss';
import { getSimpleDateFormat } from 'utils/functions';
import { useNavigate } from 'react-router-dom';
import ActivateKitchenModal from 'components/activate-kitchen-modal';
import { CoKitchenType } from 'utils/types';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import useDashboardContext from 'contexts/dashboard.context';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete-meal-icon.svg';
import ArchiveKitchenModal from 'components/archive-kitchen-modal';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';

const DineInKitchenCard = ({ data }: { data: any }) => {
  const { name, address, event_image, created_at, updated_at, active } = data;
  const [isChecked, setIsChecked] = useState(active);
  const [loading, setLoading] = useState(false);
  const [activeKitchen, setActiveKitchen] = useState({} as CoKitchenType);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const { setActiveCokitchen, refetchCokitchens } = useDashboardContext();

  const [showTurnOnModal, setShowTurnOnModal] = useState(false);
  const navigate = useNavigate();

  const turnOnKitchen = async () => {
    setLoading(true);
    try {
      await apiService.put('marketing/cokitchen', {
        data: {
          active: isChecked,
          cokitchen_id: activeKitchen.id
        }
      });
      toast(<ToastMessage type='success' message={`${activeKitchen.name} updated successfully`} />);
    } catch {
      toast(<ToastMessage type='error' message='Error encountered' />);
    } finally {
      setShowTurnOnModal(false);
      setLoading(false);
    }
  };

  const archiveKitchen = async () => {
    setLoading(true);
    try {
      await apiService.delete(`marketing/cokitchen/delete/${activeKitchen.id}`);
      toast(
        <ToastMessage type='success' message={`${activeKitchen.name} archived successfully`} />
      );
      refetchCokitchens();
    } catch {
      toast(<ToastMessage type='error' message='Error encountered' />);
    } finally {
      setShowArchiveModal(false);
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowTurnOnModal(false);
    setIsChecked(!isChecked);
  };

  return (
    <Fragment>
      <div className='group relative dine-in-card min-h-[180px] flex gap-4 rounded px-3 py-2'>
        <figure
          className='absolute top-2 right-2 w-[30px] h-[30px] flex items-center justify-center bg-[#FAFAFA] rounded-full border border-[#E8E8E8] cursor-pointer [&_svg_path]:fill-[#858585] opacity-0 transition group-hover:opacity-100'
          onClick={() => {
            setActiveKitchen(data);
            setShowArchiveModal(true);
          }}>
          <DeleteIcon />
        </figure>

        <div className={`min-h-[180px] w-[120px] bg-red-2 rounded aspect-[1/1]`}>
          <img className='object-cover w-[180px] h-full rounded' src={event_image} />
        </div>

        <div className=' mt-3 flex flex-col justify-between w-full'>
          <div
            className='cursor-pointer'
            onClick={() => {
              setActiveKitchen(data);
              setActiveCokitchen(data);
              navigate(`${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}`);
            }}>
            <div>
              <p className='font-medium mb-2 font-xs'>{name}</p>
              <p className='text-xs text-[#595959] mb-2'>{address} </p>
              <div className='flex gap-2 items-center mb-5'>
                <CalendarAltIcon className='text-[#858585]' />
                <p className='text-[10px] text-[#858585]'>{getSimpleDateFormat(updated_at)} </p>
              </div>
            </div>
          </div>

          <div className=' border-t-[0.5px] border-[#DDDEDF] flex justify-between gap-8 items-center pt-3 pb-2'>
            <p className=' text-[10px] text-[#858585]'>Added {getSimpleDateFormat(created_at)}</p>
            <Switch
              small
              active={isChecked}
              labelPosition='right'
              className=''
              onChange={(e) => {
                setIsChecked(e);
                setActiveKitchen(data);
                setShowTurnOnModal(true);
              }}
              switchClassName='bg-red-5'
            />
          </div>
        </div>
      </div>

      {showTurnOnModal ? (
        <ActivateKitchenModal
          isChecked={isChecked}
          kitchen={activeKitchen}
          show={showTurnOnModal}
          onClose={closeModal}
          onConfirm={turnOnKitchen}
          loading={loading}
        />
      ) : null}

      {showArchiveModal ? (
        <ArchiveKitchenModal
          kitchen={activeKitchen}
          show={showArchiveModal}
          onClose={() => setShowArchiveModal(false)}
          onConfirm={archiveKitchen}
          loading={loading}
        />
      ) : null}
    </Fragment>
  );
};

export default DineInKitchenCard;
